﻿import {JsonFetchJson} from "../../Helper/FetchHelper";
import {ResponseApi} from "../../Model/ResponseApi";
import {NotificationHelper} from "../../Helper/NotificationHelper";
import {IClientModel} from "../../Model/Client/ClientModel";
import {OnClientDelete} from "../../Delegates/ClientDelegate";

export class ClientDelete {
    public static Delete = async (model: IClientModel) => {
        return JsonFetchJson.Delete<ResponseApi<boolean>>(`/client/delete/${model.Primarykey}`)
            .then(response => {
                
                if (!response.Data) {
                    NotificationHelper.Instance.error("Une erreur s'est produite. Le client n'a pas été supprimé.");
                    return response.Data;
                }
                

                OnClientDelete.Fire(model);
                return response.Data;
            })
    }
}